<template>
  <div id="content-wrapper">
    <b-form-group class="border-bottom-form">
      <div class="d-flex">
        <div class="flex-1-0">
          <b-form-input
            @keyup.enter="layDanhSachLog"
            id="filterBy"
            placeholder="Nhập từ khóa tìm kiếm"
            required
            type="text"
            v-model="requestInformation.filterBy"
          />
        </div>
        <div class="ml-2">
          <base-button button="Tìm kiếm" @click="layDanhSachLog()" />
        </div>
      </div>
      <!-- <div class="row mb-3">
        <div class="col-md-6 col-xs-12">
          <v-select
            :options="danhSachApp"
            id="id"
            label="name"
            :reduce="(app) => app.id"
            v-model="requestInformation.appId"
            :readonly="true"
            placeholder="Chọn ứng dụng"
          ></v-select>
        </div>
      </div> -->
    </b-form-group>
    <p class="color-gray-1">Tìm thấy {{ totalRows }} kết quả</p>
    <DataTable :loading="isLoadingTable" :value="items">
      <Column
        field="id"
        dataKey="id"
        headerStyle="width: 40px"
        headerClass="p-2"
        header="STT"
        bodyStyle="text-align: center"
      >
        <template #filter> </template>
        <template #body="slotProps">
          <span>{{
            (requestInformation.PageIndex - 1) * requestInformation.PageSize +
            slotProps.index +
            1
          }}</span>
        </template>
      </Column>
      <Column
        field="requestPath"
        headerClass="p-2"
        header="Tên cán bộ"
        bodyStyle="text-align: left"
      >
        <template #filter> </template>
        <template #body="slotProps">
          <span>{{ slotProps.data.userName }}</span>
        </template>
      </Column>
      <Column
        field="requestPath"
        headerStyle="min-width: 200px"
        headerClass="p-2"
        header="Action"
        bodyStyle="text-align: left"
      >
        <template #filter> </template>
        <template #body="slotProps">
          <span v-html="slotProps.data.requestPath"></span>
        </template>
      </Column>

      <Column
        field="createdDate"
        headerStyle="min-width: 200px"
        headerClass="p-2"
        header="Ngày tạo"
        bodyStyle="text-align: left"
      >
        <template #filter> </template>
        <template #body="slotProps">
          <span>{{ formatDate(slotProps.data.createdDate) }}</span>
        </template>
      </Column>
      <Column
        field="requestPath"
        headerStyle="min-width: 200px"
        headerClass="p-2"
        header="Request body"
        bodyStyle="text-align: left"
      >
        <template #filter> </template>
        <template #body="slotProps">
          <span v-html="slotProps.data.requestBody"></span>
        </template>
      </Column>

      <template #empty
        ><div class="text-center">Không có dữ liệu</div></template
      >
      <template #loading
        ><div class="text-center">Đang tải dữ liệu ...</div>
      </template>
    </DataTable>

    <BasePagination
      class="mt-3"
      :current-page="requestInformation.PageIndex"
      :total-pages="totalPages"
      :total-rows="totalRows"
      @changeNum="onChangeNum($event)"
      @changePages="onChangePages($event)"
    />
  </div>
</template>
<script>
import BasePagination from "@/components/common/BasePagination";
import { mapGetters } from "vuex";
import _isEmpty from "lodash/isEmpty";
import { NO_RESULTS_TEXT, BANG_DANH_SACH_LOG } from "@/constants/constants";
import _isNil from "lodash/isNil";
import moment from "moment";
import {
  getValueFromStorageByKey,
  LOCAL_STORAGE_KEY,
} from "@/utils/localStorage";

export default {
  name: "DanhSachLogTrongApp",
  components: {
    BasePagination,
  },
  data() {
    return {
      NO_RESULTS_TEXT: NO_RESULTS_TEXT,
      items: [],
      totalPages: 0,
      totalRows: 0,
      isLoadingTable: true,
      requestInformation: {
        appId: null,
        filterBy: "",
        PageSize: 10,
        PageIndex: 1,
      },
    };
  },
  computed: {
    ...mapGetters({
      danhSachApp: "app/tatCaApp",
      danhSachLogTheoApp: "log/danhSachLogTrongAppPaging",
      appId: "common/appId",
    }),
    hasPageData() {
      return !_isEmpty(this.items);
    },
  },
  watch: {
    appId: {
      handler() {
        this.requestInformation.appId = this.appId;
      },
    },
    "requestInformation.appId": {
      handler() {
        this.layDanhSachLog();
        this.requestInformation.PageIndex = 1;
      },
      deep: true,
    },
    danhSachLogTheoApp: {
      handler() {
        this.totalPages = this.danhSachLogTheoApp.totalPage;
        this.totalRows = _isNil(this.danhSachLogTheoApp.totalCount)
          ? 0
          : this.danhSachLogTheoApp.totalCount;
        if (!_isEmpty(this.danhSachLogTheoApp)) {
          this.items = this.danhSachLogTheoApp.items;
          console.log(this.items);
        }
      },
      deep: true,
    },
  },
  async created() {
    let appId = getValueFromStorageByKey(LOCAL_STORAGE_KEY.APP_ID);
    this.requestInformation.appId = appId;

    this.layDanhSachApp();
    this.layDanhSachLog();
  },
  methods: {
    formatDate(date) {
      if (!date) return "";
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
    getInternalForm() {
      return this.internalForm;
    },
    layDanhSachApp() {
      this.$store.dispatch("app/layTatCaApp");
    },
    layDanhSachLog() {
      this.isLoadingTable = true;
      this.$store
        .dispatch("log/layDanhSachLogTheoAppPaging", this.requestInformation)
        .then(() => {
          this.isLoadingTable = false;
        });
    },
    onChangeNum(PageSize) {
      this.requestInformation.PageIndex = 1;
      this.requestInformation.PageSize = PageSize;
      this.layDanhSachLog();
    },
    onChangePages(page) {
      this.requestInformation.PageIndex = page;
      this.layDanhSachLog();
    },
  },
};
</script>